import * as t from './actionTypes';
import * as actions from './actions';
import FeatureFlags from './components/FeatureFlags';

export { default as featureFlagsReducer } from './reducer';
export * from './sagas';

export { t, actions };

export default FeatureFlags;
